import { UserService } from '@/service/UserService'
import { useAppStore } from '@/store/app'
import { getRecipientParamsFromContact, RecipientEntityTypeEnum, USER_ROLE, USER_ROLE_TYPE } from '@gohighlevel/ghl-proposals-common'
import { computed, ref } from 'vue'

export const useUsers = () => {
  const appStore = useAppStore()
  const loading = ref(false)
  const fetchUser = async (userId: string): Promise<any> => {
    try {
      loading.value = true
      const data = await UserService.getUserById(userId)
      return data
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      loading.value = false
    }
  }

  const locationStaffs = computed(() => {
    // Get the current logged in user data
    const userData = appStore?.userData

    // Check if user is account type with user role - restrict access
    if (userData?.roles?.type === USER_ROLE_TYPE.ACCOUNT && userData?.roles?.role === USER_ROLE.USER) {
      return []
    }

    const users = appStore?.locationStaffUsers || []
    const staffMap = users.map(user => {
      const userDetails = {
        ...user,
        firstName: user.first_name || '',
        lastName: user.last_name || '',
        contactName: `${user.first_name} ${user.last_name}`,
      }
      const contactDetails = getRecipientParamsFromContact(userDetails, RecipientEntityTypeEnum.USERS, false)
      return { ...contactDetails }
    })
    return staffMap
  })

  return {
    loading,
    fetchUser,
    locationStaffs,
  }
}
